<template>
  <div class="home">
    <!-- banner -->
    <banner/>
    <!-- works -->
    <works/>
    <edu/>
    <!-- secure -->
    <secure/>
    <!-- 套餐引入 -->
    <div class="p-home-price">
      <p class="p-home-price-title">选择适合贵机构的WPS 365 教育套餐</p>
      <p class="p-home-price-desc">WPS 365 教育版根据成员角色和使用场景推出了多个套餐，总有一个套餐能满足您的需求</p>
      <p class="p-home-price-detail" @click="toPrice">查看完整套餐介绍 ></p>
      <PricePkgs />
    </div>
    <custom></custom>
    <FooterBanner></FooterBanner>
  </div>
</template>

<script>
import Banner from './components/Banner.vue'
import Works from './components/Work.vue'
import Edu from './components/Edu.vue'
import Secure from './components/Secure.vue'
import PricePkgs from '@/components/PricePkgs'
import Custom from './components/Custom'
import SubBanner from './components/SubBanner.vue'
import FooterBanner from './components/FooterBanner.vue'
import infoCollect from '@/common/infoCollect';
import { getFromPage } from '@/common/utils/index'

export default {
  name: 'HomeView',
  components: { Banner, Works, Secure, SubBanner, Edu, PricePkgs, Custom, FooterBanner},
  data() {
    return {
      isPc: true
    }
  },
  mounted() {
    infoCollect.dwCollectData('page_show', 'edu_web_home_page', 'PC')
  },
  methods: {
    toLogin () {
    },
    toSwitchAccount () {
    },
    toPrice() {
      infoCollect.dwCollectData('button_click', 'look_complete_introduction', 'PC',
        {'page_name': 'edu_web_home_page', 'from_item': getFromPage()}
      )
      this.$router.push('/price?fromPage=edu_web_home_page')
    }
  }
}
</script>
<style lang="scss" scoped>
.home{
  min-height: 100vh;
  min-width: 768px;
}

.p-home-price {
  background: #F8F9FA;
  background: url('@/assets/images/home/bg-home-price.png') center;
  background-size: cover;
  text-align: center;
  overflow-x: hidden;
  padding: 83px 48px 74px 48px;
  &-title {
    font-weight: 700;
    font-size: 36px;
    line-height: 64px;
    color: rgba(13, 13, 13, 0.9);
  }

  &-desc {
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 30px;
    color: rgba(13, 13, 13, 0.66);
  }

  &-detail {
    font-weight: 400;
    font-size: 16px;
    line-height: 21px;
    color: #2953C8;
    cursor: pointer;
    margin-bottom: 60px;
  }
}
</style>
